export var CamundaWorkflowKey;
(function (CamundaWorkflowKey) {
    CamundaWorkflowKey["DOCUMENTUPLOAD"] = "ZWKFL_PAR_000010";
})(CamundaWorkflowKey || (CamundaWorkflowKey = {}));
export const postPartyDocumentTask = {
    source: 'app',
    route: '/party/document/uploadtask',
    method: 'POST',
};
